<template>
  <div class="d-flex flex-column align-center">
    <v-avatar size="230" rounded>
      <img :src="avatar" alt="Avatar" />
      <v-file-input
        v-if="['super_admin', 'education_manager'].includes(role.type)"
        class="file-input"
        :rules="rules"
        accept="image/png, image/jpeg, image/bmp"
        prepend-icon="mdi-camera"
        hide-input
        @change="onChange"
        ref="file"
      ></v-file-input>
    </v-avatar>
    <v-btn
      @click="destroy"
      color="error"
      small
      text
      class="mt-3"
      v-if="this.student.avatar && ['super_admin', 'education_manager'].includes(role.type)"
    >
      <v-icon>mdi-delete</v-icon>
      Xóa avatar
    </v-btn>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    student: Object,
    type: String
  },
  data: () => ({
    rules: [
      value => !value || value.size < 2000000 || 'Ảnh đại diện cần có dung lượng nhỏ hơn 2 MB!'
    ],
    url: '/default-avatar.png'
  }),
  computed: {
    ...mapState('auth', ['user', 'role']),
    avatar() {
      if (this.student.avatar && this.student.avatar.url) {
        const imgUrl = this.student.avatar.url
        if (!/^http/.test(imgUrl)) {
          return `${process.env.VUE_APP_API_ENDPOINT}${imgUrl}`
        } else {
          return imgUrl
        }
      }
      return this.url
    }
  },
  methods: {
    ...mapActions('teacher', { uploadTeacherAvatar: 'uploadAvatar' }),
    ...mapActions('teacher', { destroyTeacherAvatar: 'destroyAvatar' }),
    ...mapActions('student', { uploadStudentAvatar: 'uploadAvatar' }),
    ...mapActions('student', { destroyStudentAvatar: 'destroyAvatar' }),
    ...mapActions('staff', { uploadStaffAvatar: 'uploadAvatar' }),
    ...mapActions('staff', { destroyStaffAvatar: 'destroyAvatar' }),

    onChange(file) {
      if (file) {
        this.save(file)
      }
    },
    async save(image) {
      try {
        if (this.student.avatar) {
          if (this.type === 'teacher') {
            await this.destroyTeacherAvatar(this.student.avatar.id)
          } else if (this.type === 'student') {
            await this.destroyStudentAvatar(this.student.avatar.id)
          } else if (this.type === 'staff') {
            await this.destroyStaffAvatar(this.student.avatar.id)
          }
        }
        let formData = new FormData()
        formData.append('files', image)
        formData.append('refId', this.student.id)
        formData.append('ref', this.type)
        formData.append('field', 'avatar')

        if (this.type === 'teacher') {
          await this.uploadTeacherAvatar(formData)
        } else if (this.type === 'student') {
          await this.uploadStudentAvatar(formData)
        } else if (this.type === 'staff') {
          await this.uploadStaffAvatar(formData)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.$alert.success('Cập nhật thành công')
        this.$emit('updated')
      }
    },
    async destroy() {
      try {
        if (this.student.avatar) {
          if (this.type === 'teacher') {
            await this.destroyTeacherAvatar(this.student.avatar.id)
          } else if (this.type === 'student') {
            await this.destroyStudentAvatar(this.student.avatar.id)
          } else if (this.type === 'staff') {
            await this.destroyStaffAvatar(this.student.avatar.id)
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.$alert.success('Cập nhật thành công')
        this.$refs.file.$refs.input.value = null
        this.$emit('updated')
      }
    }
  }
}
</script>

<style scoped>
.file-input {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
